import React, { useEffect } from 'react'
import { useSnackbar } from 'notistack'
import { titulonavbar } from "../services/apirest";
import { subscribeTopic, onMqttError } from './mqttClient'

// Convierte un string con \n, \\n (escapado) o <br/> literal en líneas con <br/> real
const renderMultilineMessage = (text) => {
  const lines = text
    .replace(/\\n/g, '\n')          // \n escapado (viene de JSON)
    .replace(/<br\s*\/?>/gi, '\n')  // <br/>, <br>, <BR/> literales en el texto
    .split('\n')
    .filter((line, i, arr) => !(line.trim() === '' && i === arr.length - 1)) // saca línea vacía final si el mensaje termina en <br/>
  return (
    <div>
      {lines.map((line, i) => (
        <React.Fragment key={i}>
          {i > 0 && <br />}
          {line}
        </React.Fragment>
      ))}
    </div>
  )
}

const MqttSubscriber = () => {
  const { enqueueSnackbar } = useSnackbar()

  useEffect(() => {
    const topics = ['netizar/sistemas', 'netizar/produccion', `netizar/${titulonavbar}`]

    const handler = (topic, message) => {
      const messageText = message.toString().trim()

      // Verificar si el mensaje es JSON
      let isJson = false
      let parsedMessage = messageText

      try {
        parsedMessage = JSON.parse(messageText)
        isJson = true
      } catch (e) {
        isJson = false // Si no se puede parsear, no es JSON
      }

      // Condición para texto plano o JSON válido
      if (messageText && (!isJson || (isJson && Object.keys(parsedMessage).length > 0))) {
        const textoFinal = isJson
          ? JSON.stringify(parsedMessage, null, 2) // con indentación, más legible
          : messageText

        enqueueSnackbar(renderMultilineMessage(textoFinal), {
          variant: topic === 'netizar/sistemas' ? 'info' : 'error',
          persist: true,
        })
      } else {
        console.log('Mensaje vacío o JSON inválido recibido, no se muestra Snackbar.')
      }
    }

    const offs = topics.map((t) => subscribeTopic(t, handler))

    const offError = onMqttError((err) => {
      enqueueSnackbar(`Error MQTT: ${err.message}`, { variant: 'error', preventDuplicate: true })
    })

    // Al desmontar solo se desuscribe; la conexión compartida sigue viva
    return () => {
      offs.forEach((off) => off())
      offError()
    }
  }, [enqueueSnackbar])

  return <div></div>
}

export default MqttSubscriber